<template>
  <v-input :value="value" :rules="rules">
    <label v-if="value === undefined" style="position:absolute;top:0;left:0;">{{ label }}</label>
    <label v-else style="position:absolute;top:0;left:0;color:rgba(0, 0, 0, 0.67);font-weight: 400;font-size: 12px;">{{ label }}</label>
    <div style="margin-top:22px">
      <span v-if="value !== undefined" style='word-wrap: anywhere; white-space: pre-wrap;'>
        <a :href="value" target="_blank">{{ value }}</a>
      </span>
      <div>
        <template v-if="value === undefined">
          <v-btn @click="showPicker = true" color="success" small>
            {{ $t("globals.add") }}
          </v-btn>
        </template>
        <template v-else>
          <v-btn @click="showPicker = true" color="primary" small>
            {{ $t("components.portal.image_picker.change") }}
          </v-btn>
          <v-btn @click="$emit(`update:value`, undefined)" color="error" text small>
            {{ $t("globals.remove") }}
          </v-btn>
        </template>
      </div>
      <v-dialog v-model="showPicker" scrollable persistent max-width="800">
        <material-card
          :title="$t('components.portal.image_picker.upload_file')"
          icon="toggle_on"
          :color="$vuetify.theme.themes.light.success"
        >
          <v-card-text>
            <file-uploader
              v-if="showPicker"
              v-on:upload-started="onUploadStarted"
              v-on:upload-error="onUploadError"
              v-on:upload-completed="onUploadCompleted($event)"
            ></file-uploader>
          </v-card-text>
          <v-card-actions>
            <v-btn
              :loading="uploading"
              text
              @click="
                showPicker = false;
                selectedFile = undefined;
              "
            >
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn
              :loading="uploading"
              :disabled="!selectedFile"
              color="primary"
              @click="save"
            >
              {{ $t("globals.save") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
    </div>
  </v-input>
</template>

<script>
import FileUploader from "./FileUploader.vue";
export default {
  components: {
    FileUploader,
  },
  props: ["value", "rules", "label"],
  data: () => ({
    selectedFile: undefined,
    showPicker: false,
    uploading: false,
    errorMessages: [],
  }),
  watch: {
    value: {
      handler(v) {
        // this.validate(v);
      },
    },
  },
  mounted() {
    // this.validate(this.value);
  },
  methods: {
    onUploadCompleted(res) {
      // console.log(res);
      this.uploading = false;
      this.selectedFile = res[0].Name;
    },
    onUploadStarted() {
      this.uploading = true;
    },
    onUploadError() {
      this.uploading = false;
    },
    previewFile() {
      window.open(``);
    },
    save() {
      console.log(this.selectedFile);
      this.errorMessages = [];
      this.$emit("update:value", this.selectedFile);
      this.showPicker = false;
      this.selectedFile = undefined;
    },
    // validate(v) {
    //   for (let rule of this.rules) {
    //     console.log(rule, rule(v));
    //     let valid = rule(v);
    //     if (valid !== true) {
    //       this.errorMessages = [valid];
    //       return;
    //     }
    //   }
    //   this.errorMessages = [];
    // },
  },
};
</script>
